exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".presentation > .row:nth-child(odd) {\n  background-color: rgba(93, 156, 236, 0.34); }\n\n.row {\n  margin-right: -10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/debian/git/lea/lea-front/src/app/shared/cours/show/show.component.scss
// module id = ../../../../../src/app/shared/cours/show/show.component.scss
// module chunks = main